import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      {/* Wave divider */}
      <div className="footer-wave">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#0F0D0A"/>
        </svg>
      </div>

      <div className="footer-body">
        <div className="footer-container">

          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo spacex-logo">
              <img src="/logo2.png" alt="Dant Sanjeevani logo" className="site-logo-image footer-site-logo-image" />
              <span className="site-logo-copy footer-logo-copy" aria-hidden="true">
                <span className="site-logo-title">DANT SANJEEVANI</span>
                <span className="site-logo-tagline">MAXILLOFACIAL &amp; CLEFT CLINIC</span>
              </span>
            </Link>
            <p>Dant Sanjeevani is a maxillofacial and cleft clinic in Gorakhpur led by Dr. Sangeeta Arvind, with a focus on oral surgery, implantology, and cleft care.</p>
            <div className="footer-socials">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="footer-social">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="footer-social">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter" className="footer-social">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"/></svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="footer-social">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0F0D0A"/></svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              {['General Dentistry','Teeth Whitening','Dental Implants','Porcelain Veneers','Orthodontics','Emergency Care'].map(s => (
                <li key={s}><Link to="/services">{s}</Link></li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/team">Our Team</Link></li>
              <li><Link to="/testimonials">Patient Reviews</Link></li>
              <li><Link to="/contact">Book Appointment</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact Us</h4>
            <ul className="footer-contact-list">
              <li>
                <span className="fc-icon">📍</span>
                <span>First Floor, SBI Building, Girdharganj Bazar,<br/>In front of AIIMS Gate No. 4, Gorakhpur - 273008</span>
              </li>
              <li>
                <span className="fc-icon">📞</span>
                <span><a href="tel:+919044793270">+91 9044793270</a><br/><a href="tel:+9105513177523">0551-3177523</a></span>
              </li>
              <li>
                <span className="fc-icon">✉️</span>
                <a href="mailto:dantsanjeevani@gmail.com">dantsanjeevani@gmail.com</a>
              </li>
              <li>
                <span className="fc-icon">🕐</span>
                <span>Please call to confirm clinic timings before visiting.</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Google Maps Embed */}
        <div className="footer-map-section">
          <div className="footer-container">
            <h4 className="footer-map-title">
              <span className="footer-map-pin">📍</span> Find Us — Dant Sanjeevani, AIIMS Gate No. 4, Gorakhpur
            </h4>
            <div className="footer-map-wrap">
              <iframe
                title="Dant Sanjeevani Location"
                src="https://www.google.com/maps?q=First%20Floor%2C%20SBI%20Building%2C%20Girdharganj%20Bazar%2C%20In%20front%20of%20AIIMS%20Gate%20No.%204%2C%20Gorakhpur%20-%20273008&z=15&output=embed"
                width="100%"
                height="280"
                style={{ border: 'none', borderRadius: '14px', display: 'block' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <a
                href="https://maps.google.com/?q=First+Floor+SBI+Building+Girdharganj+Bazar+AIIMS+Gate+No+4+Gorakhpur+273008"
                target="_blank"
                rel="noreferrer"
                className="footer-map-open-btn"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>

        {/* Newsletter strip */}
        <div className="footer-newsletter">
          <div className="footer-container newsletter-inner">
            <div className="newsletter-text">
              <h4>Stay Informed</h4>
              <p>Get dental tips, special offers and clinic updates.</p>
            </div>
            <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
              <input type="email" placeholder="Your email address" />
              <button type="submit" className="btn-primary">Subscribe</button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <div className="footer-container footer-bottom-inner">
            <p>© 2025 Dant Sanjeevani. All rights reserved. Led by Dr. Sangeeta Arvind.</p>
            <div className="footer-bottom-links">
              <a href="#top">Privacy Policy</a>
              <a href="#top">Terms of Service</a>
              <a href="#top">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
